/* tslint:disable:max-classes-per-file */
import React from 'react';
import { Routing, Utils } from '@singularsystems/neo-core';
import { observer } from 'mobx-react';
import Scrollbar from 'react-custom-scrollbars';
import { AppService, Types } from '../Services/AppService';
import { IAppLayout, ScreenSize } from '../Services/AppLayout';
import sidebarBackground from '../assets/img/Placeholder-logo.jpg';
import { Neo } from "@singularsystems/neo-react";

interface ISidebarProps {
    /**
     * If set to true, will make sub-menu items the same size as parent items.
     */
    fixedItemSize?: boolean;
}

@observer
class Sidebar extends React.Component<ISidebarProps> {

    private routeService = AppService.get(Types.App.Services.RouteService);
    private appLayout = AppService.get(Types.App.Services.AppLayout);

    private menuContainer: React.RefObject<HTMLDivElement | null>;

    constructor(props: any) {
        super(props);

        this.menuContainer = React.createRef<HTMLDivElement>();
        this.mouseEnter = this.mouseEnter.bind(this);
        this.mouseLeave = this.mouseLeave.bind(this);
    }

    private mouseEnter() {
        this.appLayout.menuHover(true);
    }
    private mouseLeave() {
        this.appLayout.menuHover(false);
    }

    public render() {
        const layout = this.appLayout;

        const menuItemProvider = AppService.get(Types.Neo.Routing.MenuItemProvider);
        const menuItems = menuItemProvider.processRoutes(this.routeService.routes.menuRoutes, { collapseSingle: false, hideWhenEmpty: true });

        return (
            <div>
                <div className="menu-overlay"></div>
                <div ref={this.menuContainer}
                    id="left-panel"
                    className="app-left-panel"
                    onMouseEnter={this.mouseEnter}
                    onMouseLeave={this.mouseLeave}>

                    <div className={"sidebar" + (this.props.fixedItemSize ? " sidebar-fixed-item-size" : "")}>
                        <div className="sidebar-header">
                            <img src={sidebarBackground} alt="" />
                        </div>

                        <div className="sidebar-content">
                            {/* Full screen menu */}
                            {layout.currentScreenSize > ScreenSize.Small &&
                                <Scrollbar height="100%" hideTracksWhenNotNeeded>
                                    <Menu items={menuItems} level={1} appLayout={this.appLayout} />
                                </Scrollbar>}

                            {/* Small screen menu */}
                            {layout.currentScreenSize <= ScreenSize.Small &&
                                <Menu items={menuItems} level={1} appLayout={this.appLayout} />}

                        </div>
                    </div>
                </div>

            </div>

        );
    }
}

interface IMenuProps {
    appLayout: IAppLayout;
    items: Routing.IMenuRoute[];
    level: number;
}

@observer
class Menu extends React.Component<IMenuProps> {

    public render() {

        return (
            <ul className={"menu-level-" + this.props.level}>
                {this.props.items.map(item => <MenuItem key={item.path || item.name} item={item} level={this.props.level} appLayout={this.props.appLayout} />)}
            </ul>
        )
    }
}

interface IMenuItemProps {
    appLayout: IAppLayout;
    item: Routing.IMenuRoute;
    level: number;
}

@observer
class MenuItem extends React.Component<IMenuItemProps> {

    constructor(props: IMenuItemProps) {
        super(props);
    }

    public render() {
        const item = this.props.item;
        const hasChildren = !!item.children;
        const isHeader = item.children && !item.path;

        let fakeIconText = "";
        if (!item.icon) {
            let matches = item.name.match(/\b(\w)/g);
            let acronym = matches?.join('');
            if (acronym) {
                fakeIconText = acronym.substr(0, 2);
            }
        }

        let icon = isHeader ? null : 
            <div className="sidebar-icon-container">
                {(item.icon ? <i className={"sidebar-icon fa-fw " + Utils.getFontAwesomeClass(item.icon)} /> : <span className="sidebar-icon fake-icon">{fakeIconText}</span>)}
            </div>

        let text = <span className="menu-item-text">{item.name}</span>;
        let itemContent = <>
            {icon}
            {text}
        </> 

        return (
            <li>
                <div className={"menu-item" + (hasChildren ? " has-children" : "")}>

                    {item.path ?
                        <Neo.Link isNav exact={item.exact || hasChildren} to={item.path}>
                            {itemContent}
                        </Neo.Link> :
                        <span className="static-item">
                            {itemContent}
                        </span>
                    }
                </div>

                {item.children && <Menu items={item.children} level={this.props.level + 1} appLayout={this.props.appLayout} />}
            </li>)
    }
}

export default Sidebar;